import { render, staticRenderFns } from "./PurchaseStatusUpdateWidget.view.vue?vue&type=template&id=376c6127&"
import script from "./PurchaseStatusUpdateWidget.view.vue?vue&type=script&lang=js&"
export * from "./PurchaseStatusUpdateWidget.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('376c6127')) {
      api.createRecord('376c6127', component.options)
    } else {
      api.reload('376c6127', component.options)
    }
    module.hot.accept("./PurchaseStatusUpdateWidget.view.vue?vue&type=template&id=376c6127&", function () {
      api.rerender('376c6127', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/item/view/partials/update/PurchaseStatusUpdateWidget.view.vue"
export default component.exports